import { sizer } from "layout/styles/styled/sizer";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

import { ChatsTable } from "./components/ChatsTable";
import { FilesTable } from "./components/FilesTable";
import { ModelsTable } from "./components/ModelsTable";

const StyledButton = styled(Button)`
  gap: ${sizer(2)};
`;

const FlexWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

export function Chatbot() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = () => {
    if (location.pathname.includes("/models")) return 0;
    if (location.pathname.includes("/files")) return 1;
    if (location.pathname.includes("/chats")) return 2;
    return 0; // default to models
  };

  const handleTabChange = (index: number) => {
    switch (index) {
      case 0:
        navigate("/chatbot/models");
        break;
      case 1:
        navigate("/chatbot/files");
        break;
      case 2:
        navigate("/chatbot/chats");
        break;
      default:
        navigate("/chatbot/models");
        break;
    }
  };

  return (
    <TabView
      className="w-full"
      activeIndex={getActiveTab()}
      onTabChange={(e) => handleTabChange(e.index)}
    >
      <TabPanel header="Models">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-plus"
            className="p-button-raised"
            onClick={() => navigate("/chatbot/models/new")}
          >
            Create New Model
          </StyledButton>
        </FlexWrapper>
        <ModelsTable />
      </TabPanel>

      <TabPanel header="Files">
        <FlexWrapper>
          <StyledButton
            icon="pi pi-upload"
            className="p-button-raised"
            onClick={() => navigate("/chatbot/files/upload")}
          >
            Upload File
          </StyledButton>
        </FlexWrapper>
        <FilesTable />
      </TabPanel>

      <TabPanel header="Chats">
        <ChatsTable />
      </TabPanel>
    </TabView>
  );
}
